import type { DropEvent, FileRejection } from 'react-dropzone';
import { useDropzone } from 'react-dropzone';

export interface UseImageDropzoneProps {
  disabled?: boolean;
  accept?: string[];
  onDropAccepted: (file: File, event: DropEvent) => void;
  onDropRejected: (file: FileRejection, event: DropEvent) => void;
}

export const useImageDropzone = ({
  disabled,
  accept = ['JPEG', 'PNG', 'GIF'],
  onDropAccepted,
  onDropRejected,
}: UseImageDropzoneProps) =>
  useDropzone({
    disabled,
    multiple: false,
    maxSize: 10485760,
    minSize: 0,
    accept: accept.map((format) => `image/${format.toLowerCase()}`),
    maxFiles: 1,
    onDropAccepted: (files, event) => onDropAccepted(files[0], event),
    onDropRejected: (files, event) => onDropRejected(files[0], event),
  });
